module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAOpJREFUOBHtkzEKwjAUhhuVziIIzk6Frh7BWzh4AXERHLyBk4O7h3ARdBY6OHYq4gXExVHF+AXikjaFNIKD/vARkvR977XQIPjnq19AShnBBvofGQRRExZwB5UU6l5yBF04g5mRl1gVY9ybVvYXaHnJEfTgCWaWXmI99cq0sn9A7CVH0IErmNnpxoKLATScG1E0Na16P2NN4OQs1VOFFB+1rGhZ28Q124U6F0LcWCYlz6S2u1KxLlLfUDUoSjUx7x5hG4JtAKu4aIrcGQ3aMIYDvKN+9zD3cNUDZDHMYevsoCgD12TOjX6j4AUeYlZpD3L8qgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_ZalighDown_normal.png
// module id = 330
// module chunks = 0